export default __webpack_public_path__ + "static/media/sidebar-usage.38ceccba.svg";